import { useContext, useEffect, useReducer } from "react"
import { useTranslation } from "react-i18next"
import BannerContext, { BannerReducer, initialState } from "./context"
import { Banner, BannerIconContainer } from "./styles"
import { ReactComponent as AlertIcon } from "assets/icons/exclamation.svg"
import { BannerChannel } from "./utils"

const BannerProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [bannerState, dispatch] = useReducer(
    BannerReducer,
    BannerReducer(initialState, localStorage.getItem("environment-banner"))
  )
  return (
    <BannerContext.Provider value={{ bannerState, dispatch }}>
      {children}
    </BannerContext.Provider>
  )
}

export const EnvironmentBanner: React.FC = () => {
  const { bannerState, dispatch } = useContext(BannerContext)
  const { t } = useTranslation("translation")

  useEffect(() => {
    const bannerChannel = new BroadcastChannel(BannerChannel.Name)
    bannerChannel.onmessage = (event) => {
      if (event.data === BannerChannel.DevelopmentEvent) {
        dispatch("development")
      }
      if (event.data === BannerChannel.StagingEvent) {
        dispatch("staging")
      }
      if (event.data === BannerChannel.MaintenanceEvent) {
        dispatch("maintenance")
      }
      if (event.data === BannerChannel.ProductionEvent) {
        dispatch("production")
      }
    }
    return () => bannerChannel.close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!bannerState.visible) {
    return null
  }
  return (
    <Banner color={bannerState.color} background={bannerState.background}>
      <BannerIconContainer>
        <AlertIcon />
      </BannerIconContainer>
      {t(bannerState.content)}
    </Banner>
  )
}

export default BannerProvider
